const callback = {
    authenticating: '正在完成身份认证，请稍后...',
    loginFailed: '登录失败 (401 invalid_client)',
    loginFailedDesc: '这通常意味着你的 App ID 与应用类型不匹配。',
    errorMessage: '当前错误信息:',
    retryLogin: '返回登录页重试',
  }

export default callback
